module.exports = __webpack_public_path__ + "static/media/close.5efe3c65.svg";